"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The enum used for increase or decrease indentation of a block
 * Used by setIndentation API
 */
var Indentation;
(function (Indentation) {
    /**
     * Increase indentation
     */
    Indentation[Indentation["Increase"] = 0] = "Increase";
    /**
     * Decrease indentation
     */
    Indentation[Indentation["Decrease"] = 1] = "Decrease";
})(Indentation = exports.Indentation || (exports.Indentation = {}));
//# sourceMappingURL=Indentation.js.map